import { toast } from '@webapp/components/Notification'
import { getMessageFromError } from '@webapp/core/utils/errors/getMessageFromError'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { useMutateDenyExpense } from '../../models/useMutateDenyExpense'

interface UseDenyExpensePresenterParams {
  expenseId: number
  onSuccess: () => void
}

export const useDenyExpensePresenter = ({
  expenseId,
  onSuccess,
}: UseDenyExpensePresenterParams) => {
  const intl = useProcurifyIntl()
  const { mutate, isLoading } = useMutateDenyExpense()

  const deny = async () => {
    try {
      await mutate(expenseId)

      toast.success({
        title: intl.formatMessage(messages.denySuccess, { expenseId }),
      })

      window.analytics?.track('Document Denied', { type: 'expense' })

      onSuccess()
    } catch (err) {
      const errorMessage = getMessageFromError(err)

      toast.error({
        title: intl.formatMessage(messages.denyError),
        children: errorMessage,
      })
    }
  }

  return {
    commands: {
      deny,
    },
    states: {
      isDenying: isLoading,
    },
  }
}
